import PropTypes, { number, string } from 'prop-types';

import CheckboxInput from "./CheckboxInput"

/**
 * A group of checkboxes
 * 
 * @param {object} props
 * @param {string} props.id - checkbox group ID
 * @param {string} props.name - checkbox group name
 * @param {Array} props.options - Array of option objects. Each option object should have a "value" and "label" attribute.
 * @param {string} props.label - checkbox group label
 * @param {Function} props.onChange - function that runs when an indivdual checkbox is toggled
 * @param {boolean} props.groupDisabled - true if checkboxes should be disabled, false otherwise
 * @param {Array} props.selectedValues - values that should be selected when the component renders
 */
const CheckboxGroup = ({ id, name, options, label, onChange, groupDisabled, selectedValues }) => {

    return (
        <div className="checkbox-group">
            {label && <label className='input-label' htmlFor={id}>{label}</label>}
            <div className='ms-3'>
                {options.map((option, i) => (
                    <CheckboxInput
                        id={`${id}-option[${i}]`}
                        key={i}
                        name={name}
                        value={option.value}
                        label={option.label}
                        onChange={onChange}
                        disabled={groupDisabled}
                        checked={selectedValues && selectedValues.find((v) => Number(v) === Number(option.value))}
                    />
                ))}
            </div>
        </div>
    )
};

CheckboxGroup.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([string, number]).isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    label: PropTypes.string,
    onChange: PropTypes.func,
    groupDisabled: PropTypes.bool,
    selectedValues: PropTypes.array,
}

export default CheckboxGroup;
